module.exports = __webpack_public_path__ + "media/application/images/svgs/phone-off-83faabb0c442cf504cf03537f35e9753.svg";